export default __webpack_public_path__ + "static/media/supplies.7e9e5540.png";